module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-day-6c2df3f3.svg";